import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);


interface PlotChartProps {
  data: { name: string; value: number }[];
}

const PlotChart: React.FC<PlotChartProps> = ({ data }) => {
  const chartData = {
    labels: data.map(item => item.name),
    datasets: [
      {
        label: 'Enrollments',
        data: data.map(item => item.value),
        fill: false,
        borderColor: 'rgba(75,192,192,1)',
        tension: 0.2,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' as const },
      title: { display: true, text: 'Enrollments Across All Classrooms' },
    },
  };

  return <Line data={chartData} options={options} />;
};

export default PlotChart;
